$(document).ready(function() {
  var $footertext = $('.ph-todayyear'),
      updatedtext = '',
      currentyeardata = new Date().getFullYear();

  updatedtext = $footertext.text();
  $footertext.text(updatedtext.replace('0', currentyeardata));


  $(document).on('click', '.ph-targetUrl', function(event) {
    var url = document.URL,
        index = url.indexOf('storefront') + 11,
        splitArray = url.substring(index).split('/'),
        site = splitArray[0],
        language = splitArray[1],
        currency = splitArray[2],
        newUrl = url.substring(0, index) + site + '/' + language + '/' + currency + '/';

    event.preventDefault();

    window.location = newUrl;
  });
});
